import { useState } from "react";
import { HiChartBar } from "react-icons/hi2";

import { SidebarNavElement } from "@/components/_layout/sidebar/sidebar-nav-element";
import { FeatureFlagToggle } from "@/domain/_shared/feature-flag/components/feature-flag-toggle";
import { makeWorkspaceUrl } from "@/domain/workspace/lib/make-workspace-url";
import { Workspace } from "@/domain/workspace/models/workspace-model";

import { useGetIndicatorList } from "../hooks/api/use-get-indicator-list";

interface IndicatorSidebarNavLinkProps {
  workspace: Workspace;
}

export const IndicatorSidebarNavLink = ({ workspace }: IndicatorSidebarNavLinkProps) => {
  const [hasHovered, setHasHovered] = useState(false);

  useGetIndicatorList({
    workspaceId: workspace.id,
    enabled: hasHovered,
  });

  return (
    <FeatureFlagToggle flag={"enable_indicator_page"}>
      <SidebarNavElement
        to={makeWorkspaceUrl({ workspace: workspace, path: "indicators" })}
        onMouseEnter={() => {
          setHasHovered(true);
        }}
      >
        <HiChartBar className="mr-2 h-3 w-3" />
        Indikatoren
      </SidebarNavElement>
    </FeatureFlagToggle>
  );
};
